const MESSAGE_FADE_TIME = 5000;

export const status = {
    state: () => ({ 
        message: '',
        message_type: 'is-danger',
        loading: false,
        firebase: {
          beenConnected: false,
          connected: false,
        },
    }),
    mutations: {
        SET_MESSAGE(state,message) {
            if(typeof(message) == 'object') {
                state.message = message.text 
                state.message_type = message.type
            } else {
                state.message = message 
                state.message_type = 'is-info'
            }
        },
        CLEAR_MESSAGE(state) { state.message = '' },
        SET_LOADING(state,is_it_loading) { state.loading = is_it_loading },
        CONNECT_FIREBASE(state) { state.firebase.beenConnected = true; state.firebase.connected = true; },
        DISCONNECT_FIREBASE(state) { state.firebase.connected = false; },
    },
    getters: {
        message(state) { console.log("Message:",state.message); return state.message },
        message_type(state) { return state.message_type },   
        is_loading(state) { return state.loading },
        firebase_connected(state) { return state.firebase.connected } 
    },
    actions: {
        clearStatus({commit}) { commit('CLEAR_MESSAGE') },
        setMessage({commit,dispatch},message){
            console.log("Set Message:",message);
            commit('SET_MESSAGE',message)
            if(this.timeoutMarker) { clearTimeout(this.timeoutMarker) }
            this.timeoutMarker = setTimeout(() => {
                dispatch('clearStatus')
            }, MESSAGE_FADE_TIME)
        },
        loading({commit},loading){ commit('SET_LOADING',loading) },
    },
}